import { api } from '@api'
import type { SetupFilter } from '../filter'
import type { Pagination } from '../index'
import { applyFilters } from '../utils/applyFilters'

export const handleGetPublished = async ({
  filters,
  pagination,
}: { filters: SetupFilter; pagination: Pagination }) => {

  // Point to our new unified view
  let query = api().from('setup_enriched').select('*').eq('status', 'published')

  // Map the frontend sort states to the new DB columns.
  // Use nullsFirst: false so un-scored setups sink to the bottom.
  const sortMap: Record<string, string> = {
    'recent-activity': 'updated_at',
    'recently-submitted': 'created_at',
    'takers': 'takers_count',
    'subscribers': 'subscribers_count',
    'community-score': 'community_score',
    'PHQ': 'commander_score'
  }

  const column = sortMap[filters.sort] || 'updated_at'
  query = query.order(column, { ascending: false, nullsFirst: false })

  query = applyFilters(query, filters)

  if (pagination.limit !== undefined && pagination.offset !== undefined) {
    query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
  }

  const { data } = await query
  return data || []
}
